import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'
import isNil from 'lodash-es/isNil'

import { useScreen } from '../../../../../hooks'
import { BuildingSelectFormikField } from '../../../../Building'
import { FlatSelect } from '../../../../Flat'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import { RequestSelectFormikField } from '../../../../Request'
import { APPOINTMENT_FORM_FIELD_NAME } from '../../AppointmentFormModal.constants'
import { getAppointmentFormAnchorHintKey } from '../../AppointmentFormModal.utils'
import { AppointmentFormModalHintedControl } from '../AppointmentFormModalHintedControl'

import { useAppointmentFormRequestAnchor } from './AppointmentFormModalAnchorFields.hooks'

function AppointmentFormModalAnchorFields() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  const { initialValues, setFieldValue, values } = useFormikContext()

  const { handleChangeRequest, isLoading } = useAppointmentFormRequestAnchor()

  // The request the form opened with is never re-pointed (BR-CAL-02-05)
  const isRequestReadOnly = !isNil(
    initialValues[APPOINTMENT_FORM_FIELD_NAME.request]
  )

  const isFromRequest = !isNil(values[APPOINTMENT_FORM_FIELD_NAME.request])

  const buildingId = values[APPOINTMENT_FORM_FIELD_NAME.building]?.value

  const hintKey = getAppointmentFormAnchorHintKey(values)

  function getControlProps(placeholderKey) {
    return {
      borderless: !isMobileScreenSize,
      contentProps: { inputProps: { placeholder: t(placeholderKey) } },
    }
  }

  function handleChangeBuilding() {
    setFieldValue(APPOINTMENT_FORM_FIELD_NAME.flat, null)
  }

  return (
    <>
      <RequestSelectFormikField
        closeDropdownOnClear
        controlProps={getControlProps('Appointment.FormRequestPlaceholderKey')}
        disabled={isRequestReadOnly}
        emptyValue={null}
        fieldComponentProps={{
          label: `${t('Appointment.FormRequestLabelKey')}:`,
          shouldAdaptToMobileScreen: true,
        }}
        name={APPOINTMENT_FORM_FIELD_NAME.request}
        onChange={handleChangeRequest}
        onClear={handleChangeRequest}
      />
      <BuildingSelectFormikField
        closeDropdownOnClear
        controlProps={getControlProps('Appointment.FormBuildingPlaceholderKey')}
        disabled={isFromRequest}
        emptyValue={null}
        fieldComponentProps={{
          isLoading,
          label: `${t('Appointment.FormBuildingLabelKey')}:`,
          shouldAdaptToMobileScreen: true,
        }}
        name={APPOINTMENT_FORM_FIELD_NAME.building}
        onChange={handleChangeBuilding}
        onClear={handleChangeBuilding}
      />
      <FormikField
        closeDropdownOnClear
        Component={AppointmentFormModalHintedControl}
        Control={FormFieldSelectNG}
        Select={FlatSelect}
        apiParams={buildingId ? { building: buildingId } : null}
        controlProps={getControlProps('Appointment.FormFlatPlaceholderKey')}
        disabled={isFromRequest || !buildingId}
        emptyValue={null}
        fieldComponentProps={{
          isLoading,
          label: `${t('Appointment.FormFlatLabelKey')}:`,
          shouldAdaptToMobileScreen: true,
        }}
        getErrorProps={getFormikFormFieldErrorProps}
        hint={hintKey ? t(hintKey) : null}
        name={APPOINTMENT_FORM_FIELD_NAME.flat}
      />
    </>
  )
}

export default AppointmentFormModalAnchorFields
